"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadCheckList = downloadCheckList;
exports.getCommentList = getCommentList;
exports.reconciliation = reconciliation;
exports.replyComment = replyComment;
exports.uploadReconciliationImage = uploadReconciliationImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getCommentList(query) {
  return (0, _requestAuth.default)({
    url: '/xyComment/page',
    method: 'get',
    params: query
  });
}
function replyComment(query) {
  return (0, _requestAuth.default)({
    url: '/xyComment/reply',
    method: 'post',
    data: query
  });
}
function reconciliation(query) {
  return (0, _requestAuth.default)({
    url: '/xyComment/reconciliation',
    method: 'post',
    data: query
  });
}
function downloadCheckList(query) {
  return (0, _requestAuth.default)({
    url: '/xyComment/downloadList',
    method: 'post',
    params: query
  });
}

/**
 * 上传和解图片
 */
function uploadReconciliationImage(formData) {
  return (0, _requestAuth.default)({
    url: '/xyComment/uploadReconciliationImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}